import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { getProjectsForUser } from "authoring/users/projects/controller/get-projects-for-user"
import { AuthoringUserMultiSelectCell } from "./authoring-user-multi-select-cell"

export function AuthoringUserWorkPackageCell({ user, onUpdateWorkPackages }) {
    const { projects = [] } = useBoundContext()
    const userProjectIds = getProjectsForUser.useResults({ userId: user?.id }) ?? []

    return (
        <AuthoringUserMultiSelectCell
            label="Work Packages"
            options={projects}
            selectedIds={userProjectIds}
            onToggle={handleToggle}
            dataCy={`work-package-selector-${user?.metadata?.email}`}
            inputId={`work-package-select-${user.id}`}
        />
    )

    async function handleToggle(project) {
        const isAssigned = userProjectIds.includes(project.id)
        await onUpdateWorkPackages(user, project.id, isAssigned)
    }
}
